export default __webpack_public_path__ + "static/media/eye-invisible.45e06a9c.svg";